import routesObject from "../routesObject";

import CUSTOMER_STATUSES from "./CUSTOMER_STATUSES";



export default () => ({
  [CUSTOMER_STATUSES.new]: routesObject.otp.key,
  [CUSTOMER_STATUSES.preRegistered]: routesObject.addressDetails.key,
  [CUSTOMER_STATUSES.registered]: routesObject.bankCredentials.key,
  [CUSTOMER_STATUSES.systemApproved]: routesObject.dashboard.key,
  [CUSTOMER_STATUSES.declined]: routesObject.dashboard.key,
  [CUSTOMER_STATUSES.securityChecked]: routesObject.dashboard.key,
  [CUSTOMER_STATUSES.internalCollection]: routesObject.dashboard.key,
  [CUSTOMER_STATUSES.externalCollection]: routesObject.dashboard.key,
  [CUSTOMER_STATUSES.processCollection]: routesObject.dashboard.key,
  [CUSTOMER_STATUSES.demand]: routesObject.dashboard.key,
  [CUSTOMER_STATUSES.reclamation]: routesObject.dashboard.key,
  [CUSTOMER_STATUSES.fraud]: routesObject.dashboard.key,
  [CUSTOMER_STATUSES.legalCollection]: routesObject.dashboard.key
});
